import React, { useCallback } from 'react';
import styles from './FilterDrawerNew.module.scss';
import { Drawer } from 'antd';
import { ReactComponent as FilterDocumentIcon } from '../../../resource/FilterDocumentIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import FormFilter from './conponents/FormFilter/FormFilter';
import FooterFilter from './conponents/FooterFilter/FooterFilter';
import { documentsActions } from '../store/actions/documents.actions';
import {
  resetFilter,
  setFilterChanged,
} from '../store/actions/documentFilterNew.actions';
import resetDocumentDefaultFilter from '../requests/resetDocumentDefaultFilter';
import { chosenFilterIdSelector } from '../store/selectors/new-document.selector';

const FilterHeader = () => {
  return (
    <div className={styles.header}>
      <FilterDocumentIcon />
      <div>Фильтр документов</div>
    </div>
  );
};

const FilterDrawerNew = () => {
  const filterNewVisible = useSelector(
    (store) => store.documentsStore.filterNewVisible
  );

  const filterChanged = useSelector(
    (state) => state.documentFilterNewStore.filterChanged
  );

  const chosenFilterId = useSelector(chosenFilterIdSelector);

  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (filterChanged) {
      dispatch(documentsActions.setFilterNewVisible(false));
      dispatch(documentsActions.fetchDocuments());
      dispatch(setFilterChanged(false));
    }
  };

  const handleCancel = () => {
    if (filterChanged) {
      dispatch(documentsActions.fetchDocuments());
    }
    dispatch(documentsActions.setFilterNewVisible(false));
    dispatch(setFilterChanged(false));
  };

  const handleResetDefaultFilter = useCallback(() => {
    resetDocumentDefaultFilter(chosenFilterId);
    dispatch(resetFilter());
  }, [dispatch, chosenFilterId]);

  return (
    <Drawer
      visible={filterNewVisible}
      destroyOnClose
      title={<FilterHeader />}
      width="40%"
      headerStyle={{ position: 'sticky', top: 0, zIndex: 10 }}
      closable={true}
      drawerStyle={{ backgroundColor: '#F3F7FF' }}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: 0,
      }}
      onClose={handleCancel}
    >
      <div style={{ flex: 1 }}>
        <FormFilter />
      </div>
      <FooterFilter
        onSubmit={handleSubmit}
        onCancel={handleResetDefaultFilter}
      />
    </Drawer>
  );
};

export default FilterDrawerNew;
